import axios from "axios";
import { message as AntdAlert } from "antd";
import { put } from "redux-saga/effects";
import * as actions from "../actions";
import { baseURL } from "../../../../globalUtils/axiosConfig";
import { errorHandler } from "../../../../components/unauthorizeHandler";

export function* handleCreateProject({ data }) {
  try {
    const fd = new FormData();
    for (const [key, value] of Object.entries(data)) {
      if (key === "documents" && value !== undefined) {
        Array.from(value).forEach((image) => {
          const { isLocal } = image;
          if (isLocal) {
            fd.append(`documents[]`, image);
          }
          // else fd.append("image_ids[]", key);
        });
      } else if (value !== null && value !== undefined) {
        fd.append(key, value);
      }
    }
    const response = yield axios.post(`${baseURL}/api/v1/projects`, fd, {
      headers: {
        "content-type": "multipart/form-data",
      },
    });
    const { success, message } = response.data;

    if (success) {
      AntdAlert.success(message);
      yield put(actions.createProjectSuccess(response.data.data));
    } else if (!success) {
      AntdAlert.error(response.data?.errors[0]);
      yield put(actions.createProjectError());
      errorHandler(response.data);
    }
  } catch (error) {
    console.log(error);
  }
}

export function* handleUpdateProject({ data }) {
  try {
    const fd = new FormData();
    for (const [key, value] of Object.entries(data)) {
      if (key === "documents" && value !== undefined) {
        Array.from(value).forEach((image) => {
          const { isLocal } = image;
          if (isLocal) {
            fd.append(`documents[]`, image);
          }
          // else fd.append("image_ids[]", key);
        });
      } else if (value !== null && value !== undefined) {
        fd.append(key, value);
      }
    }
    const response = yield axios.put(
      `${baseURL}/api/v1/projects/${data.id}`,
      fd,
      {
        headers: {
          "content-type": "multipart/form-data",
        },
      }
    );
    const { success, message } = response.data;
    if (success) {
      AntdAlert.success(message);
      yield put(actions.updateProjectSuccess(response.data.data));
    } else if (!success) {
      AntdAlert.error(response.data?.errors[0]);
      yield put(actions.updateProjectError());
      errorHandler(response.data);
    }
  } catch (error) {
    console.log(error);
  }
}

export function* handleFetchProjectDetailsUtils() {
  try {
    const response = yield axios.get(`${baseURL}/api/v1/users/user_details`);
    const { success } = response.data;

    if (success) {
      yield put(actions.fetchProjectDetailsUtilsSuccess(response.data.data));
    }
    errorHandler(response.data);
  } catch (error) {
    console.log(error);
  }
}

export function* handleFetchAllProjects({ data }) {
  const { search, ...rest } = data;
  Object.keys(search).forEach((key) => {
    if (search[key]?.length < 1 || search[key] === null) delete search[key];
  });

  try {
    const response = yield axios.get(`${baseURL}/api/v1/projects`, {
      params: {
        ...rest,
        ...(Object.keys(search).length > 0 && {
          ...search,
          show_by_default: false,
        }),
      },
    });
    const { success } = response.data;
    if (success) {
      yield put(actions.fetchAllProjectsSuccess(response.data.data));
    } else if (!success) {
      errorHandler(response.data);
      yield put(actions.fetchAllProjectsError(response.data.data));
    }
  } catch ({ response }) {
    yield put(actions.fetchAllProjectsError(response.data.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}

export function* handleDeleteProject({ data }) {
  try {
    const response = yield axios.delete(
      `${baseURL}/api/v1/projects/${data.id}`
    );
    const { success, message } = response.data;
    if (success) {
      AntdAlert.success(message);
      yield put(actions.deleteProjectSuccess(response.data.data));
    } else if (!success) {
      errorHandler(response.data);
      yield put(actions.deleteProjectError(response.data.data));
    }
  } catch ({ response }) {
    yield put(actions.deleteProjectError(response.data.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}

export function* handleFetchProject({ data }) {
  try {
    const response = yield axios.get(`${baseURL}/api/v1/projects/${data}`);
    const { success } = response.data;

    if (success) {
      // const { permissions, ...res } = response.data.data;
      yield put(actions.fetchProjectSuccess(response.data.data));
    } else {
      yield put(actions.updateProjectError());
      errorHandler(response.data);
    }
  } catch (error) {
    console.log(error);
  }
}

export function* handleDeleteProjectAttach({ data }) {
  try {
    const response = yield axios.delete(
      `${baseURL}/api/v1/projects/delete_project_attachment`,
      {
        params: {
          id: data,
        },
      }
    );
    const { success, message } = response.data;
    if (success) {
      AntdAlert.success(message);
      yield put(actions.deleteProjectAttachSuccess(response.data.data));
    } else if (!success) {
      errorHandler(response.data);
      yield put(actions.deleteProjectAttachError(response.data.data));
    }
  } catch ({ response }) {
    yield put(actions.deleteProjectAttachError(response.data.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}

export function* handleUpdateProjectNotifications({ data }) {
  try {
    const fd = new FormData();
    for (const [key, value] of Object.entries(data)) {
      if (value !== null && value !== undefined) {
        fd.append(key, value);
      }
    }
    const response = yield axios.put(
      `${baseURL}/api/v1/projects/${data.id}`,
      fd,
      {
        headers: {
          "content-type": "multipart/form-data",
        },
      }
    );
    const { success, message } = response.data;
    if (success) {
      AntdAlert.success(message);
      yield put(actions.updateProjectNotificationsSuccess(response.data.data));
    } else if (!success) {
      AntdAlert.error(response.data?.errors[0]);
      yield put(actions.updateProjectNotificationsError());
      errorHandler(response.data);
    }
  } catch (error) {
    console.log(error);
  }
}
